import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { OutboundLink } from "gatsby-plugin-google-analytics"

const getData = graphql`
  {
    info: site {
      siteMetadata {
        contact
      }
    }
  }
`

const TermsPage = () => (
  <StaticQuery
    query={getData}
    render={data => {
      const contact = data.info.siteMetadata.contact
      return (
        <Layout>
          <SEO
            title="Terms of Use"
            description="Terms of use for 918kiss-official.app, the official 918Kiss download page: what the site provides, 18+ eligibility, and how to contact support on WhatsApp."
            pagePath="/terms/"
          />
          <div className="container">
            <div className="row">
              <div className="col-12 pt-4 appbox-copy px-3 pb-3 mb-2">
                <h1 className="h3 block-title">Terms of Use</h1>
                <p>
                  These terms apply to your use of 918kiss-official.app, the
                  official 918Kiss download page. This site exists to give you
                  working download links and installation instructions for the
                  918Kiss app. We do not operate the app itself, and this
                  website does not host game accounts, payments, or any other
                  service.
                </p>
                <h2 className="h5 block-title">What this site provides</h2>
                <p>
                  This site provides download links to the 918Kiss client
                  &mdash; an Android APK and the iOS install profile, delivered
                  through Safari &mdash; along with step-by-step installation
                  instructions. Once you are inside the 918Kiss app, the app,
                  its games, and everything you do there are governed by
                  918Kiss, not by this website.
                </p>
                <h2 className="h5 block-title">Eligibility: 18+</h2>
                <p>
                  918Kiss is a real-money games app intended for adults aged 18
                  or older only. By using this site you confirm that you are at
                  least 18 years old and that you are allowed to take part in
                  online real-money games where you are located.
                </p>
                <h2 className="h5 block-title">
                  No warranty on download links
                </h2>
                <p>
                  The download links on this site point to third-party download
                  hosts. We provide these links &ldquo;as is&rdquo; and make no
                  warranty about their availability or the behaviour of the
                  files downloaded from them. Hosts and file locations can
                  change at any time without notice. If a link stops working,
                  message us on WhatsApp and our support team will send you the
                  current working link.
                </p>
                <h2 className="h5 block-title">About this page</h2>
                <p>
                  When we call this site the official 918Kiss download page, we
                  mean that this is the page we publish for getting the 918Kiss
                  client. We do not claim to operate the 918Kiss app, its games,
                  or any service connected to it.
                </p>
                <h2 className="h5 block-title">Contact</h2>
                <p className="pb-2">
                  Questions about these terms? Message us on{" "}
                  <OutboundLink href={contact} className="link">
                    WhatsApp
                  </OutboundLink>{" "}
                  and our support team will reply.
                </p>
                <p className="pb-2 small">
                  <Link to="/">Back to home</Link>
                  {` · `}
                  <Link to="/privacy/">Privacy Policy</Link>
                  {` · `}
                  <Link to="/responsible-gaming/">Responsible Gaming</Link>
                </p>
              </div>
            </div>
          </div>
        </Layout>
      )
    }}
  />
)

export default TermsPage
